import React from 'react';
import { Alert, Chip, Tooltip } from '@mui/material';
import { Info } from '@mui/icons-material';
import { ORG_DOC_SHOW_MOCK_BADGE } from '../../Configurations/FeatureFlags';

/**
 * MockBadge Component
 * Simple badge to indicate mock data - respects feature flag
 */
export const MockBadge = ({ inline = false, size = 'small' }) => {
  if (!ORG_DOC_SHOW_MOCK_BADGE) return null;

  return (
    <Tooltip title="This is mock data. Backend integration pending." arrow>
      <Chip
        label="MOCK"
        size={size}
        color="warning"
        sx={{
          ml: inline ? 1 : 0,
          fontSize: '10px',
          height: '20px',
          fontWeight: 600
        }}
      />
    </Tooltip>
  );
};

/**
 * MockDataAlert Component
 * Alert banner to show at top of pages using mock data
 */
export const MockDataAlert = ({ message }) => {
  if (!ORG_DOC_SHOW_MOCK_BADGE) return null;

  return (
    <Alert
      severity="info"
      icon={<Info />}
      sx={{ mb: 2 }}
    >
      {message || 'This screen is using mock data. Backend integration pending.'}
    </Alert>
  );
};

/**
 * Check if data item is mock
 * @param {object} item - Data item to check
 * @returns {boolean} - Whether the item is mock data
 */
export const isMockData = (item) => {
  return item && item._isMock === true;
};

export default MockBadge;
